import { makeAutoObservable } from "mobx"
import { StorageKey } from "../constants"

export default class GoodsStore {

  isAuth: boolean = false
  userData: any = {}

  token: string = ""
  login: string = ""
  password: string = ""

  activeOrder: undefined | any = undefined
  activeInter: any = null

  constructor() {
    makeAutoObservable(this)
  }

  setActiveInter(val: any) {
    this.activeInter = val
  }

  setActiveOrder(val: any) {
    this.activeOrder = val
  }

  setIsAuth(val: boolean) {
    localStorage.setItem(StorageKey.GOODS_AUTHED, `${val}`)
    this.isAuth = val
  }

  setUserData(val: any) {
    localStorage.setItem(StorageKey.GOODS_USER, JSON.stringify(val))
    this.userData = val
  }

  setLogin(val: string) {
    this.login = val
  }

  setPassword(val: string) {
    this.password = val
  }

  setToken(val: string) {
    localStorage.setItem(StorageKey.TOKEN, val)
    this.token = val
  }

}